// extracted by mini-css-extract-plugin
module.exports = {"headerwrapper":"headerwrapper--1mXz8","headertitle":"headertitle--118g4","subtitle":"subtitle--j80GJ"};